module.exports = __webpack_public_path__ + "img/8.7abd3c01.jpg";